import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "min-h-150px" }
const _hoisted_2 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_itemFile = _resolveComponent("itemFile")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.open_dialog_file_list,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.open_dialog_file_list) = $event)),
    title: 'Archivos presentados: ' + _ctx.expediente.nro_proceedings,
    draggable: "",
    top: "4vh",
    onOpened: _ctx.getFiles,
    onClosed: _ctx.oonClosed
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-custom btn-danger btn-sm",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open_dialog_file_list = false))
        }, " Cerrar ")
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.listFiles.length>0)
          ? (_openBlock(), _createBlock(_component_itemFile, {
              key: 0,
              view: 'square',
              files: _ctx.listFiles
            }, null, 8, ["files"]))
          : (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              "image-size": 200,
              description: "No se encontrarón archivos"
            }))
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onOpened", "onClosed"]))
}